module.exports = __webpack_public_path__ + "img/IMG_0050-577x500.43862056(1).76da67fa.png";